import React from 'react'
import { Modal, Button, Form, Accordion } from 'react-bootstrap'

type PrescriptionNoteItem = {
  procedureName: string
  instructions: string
}

type PrescriptionNoteProps = {
  show: boolean
  notes: PrescriptionNoteItem[]
  title: string
  readonly?: boolean
  onChange?: (index: number, newNote: string) => void
  onSave?: () => void
  onClose: () => void
}

const PrescriptionNote: React.FC<PrescriptionNoteProps> = ({
  show,
  notes,
  title,
  readonly = false,
  onChange,
  onSave,
  onClose,
}) => {
  return (
    <Modal show={show} onHide={onClose} centered size="lg">
      <Modal.Header closeButton>
        <Modal.Title>{readonly ? 'Order instructions' : title}</Modal.Title>
      </Modal.Header>

      <Modal.Body>
        {readonly ? (
          <Accordion
            defaultActiveKey="0"
            flush
            className="prescription-note-accordion"
          >
            {notes.map((noteItem, idx) => (
              <Accordion.Item eventKey={idx.toString()} key={idx}>
                <Accordion.Header>
                  {noteItem.procedureName || `Procedure ${idx + 1}`}
                </Accordion.Header>
                <Accordion.Body className="p-2">
                  {noteItem.instructions || 'No instructions provided.'}
                </Accordion.Body>
              </Accordion.Item>
            ))}
          </Accordion>
        ) : (
          <>
            {notes.map((noteItem, idx) => (
              <div key={idx} className="lab-note-box mb-4">
                <div className="procedure-type-note-title">
                  <div className="ptnt-inner">
                    <div className="ptn-name">{noteItem.procedureName}</div>
                    <div className="ptn-more">...</div>
                  </div>
                </div>

                <div className="lab-note-field">
                  <Form.Control
                    as="textarea"
                    rows={3}
                    value={noteItem.instructions}
                    onChange={(e) => onChange?.(idx, e.target.value)}
                    placeholder="Write your instructions here..."
                  />
                </div>

                <div className="lab-note-footer d-flex justify-content-between align-items-center">
                  <span className="lab-note-icon">
                    <i className="mgc mgc_pencil_2_ai_fill" />
                  </span>

                  <button
                    type="button"
                    className="btn p-0 border-0 bg-transparent"
                    onClick={onSave}
                    title="Save note"
                  >
                    <i className="mgc mgc_send_fill fs-4" />
                  </button>
                </div>
              </div>
            ))}
          </>
        )}
      </Modal.Body>

      <Modal.Footer>
        <Button variant="secondary" className="button-md" onClick={onClose}>
          {readonly ? 'Close' : 'Cancel'}
        </Button>
      </Modal.Footer>
    </Modal>
  )
}

export default PrescriptionNote
